import './diagnostic-tooltip.css';
export var diagnosticIconClass = 'strato-diagnostic-icon-wrapper';
export var editorDiagnosticWrapperClass = 'strato-editor-diagnostic-wrapper';
export var filterFieldErrorWrapperClass = 'strato-filterfield-error-wrapper';